import axios from 'axios'
import qs from 'qs'
import utils from '@/assets/lib/utils'
const instance = axios.create({
  transformRequest: [function(data) {
    data = qs.stringify(data);
    return data;
  }]
});
const Request = (add, opt = {}) => {
  let defalutOpt = {
    loadMsg: '加载中...',
    method: 'post',
    data: {},
    auth: false
  }
  let option = Object.assign(defalutOpt, opt)
  let {
    loadMsg,
    method,
    data,
    auth
  } = option
  if (loadMsg != false) {
    utils.load(loadMsg)
  }
  if (auth == true) {
    let userInfo = utils.getStorage('userInfo')
    if (userInfo == null) {
      let callBackUri='https://wb.jzlmwl.com/dianti/api/auth'
      let redirectUri='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx878d392f0f34cf1e&redirect_uri='+callBackUri+'&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
      window.location.href=redirectUri
      return false
    }
    data.user_id = userInfo.id
  }
  let insObj = {
    url: add,
    method: method
  }
  if (method == 'post') {
    insObj.data = data
  } else {
    insObj.params = data
  }
  return instance.request(insObj).then(res => {
    if (loadMsg != false) {
      utils.loadClose()
    }
    if (res) {
      let {
        code,
        msg
      } = res.data
      if (code != 200) {
        switch (code) {
          default:
            if (typeof msg != 'undefined') {
              utils.toast(msg, 'err')
            } else {
              utils.toast('未知错误', 'err')
            }
        }
      }
    } else {
      utils.toast('未知错误', 'err')
    }
    return res.data
  }, res => {
    utils.toast('服务器异常', 'err')
  })
}
export {
  Request
}
